<template>
    <div>
        <!-- TODO: Style this like the bordered inputs -->
        <div>{{ field.title }}</div>
        <div class="d-flex mb-4 file-gap">
            <app-thumbnail
                :file="file"
                @delete="file = null" />

            <app-file-drop @input="onInput" />
        </div>
    </div>
</template>

<script>
import formFieldMixin from "./formFieldMixin";
import { get } from "@/features/schemas/services/schemaApi";

export default {
    types: [ "file" ],
    mixins: [formFieldMixin],
    props: {
        value: {
            type: [String, Number],
            default: null
        }
    },
    data() {
        return {
            file: null
        }
    },
    watch: {
        value: {
            immediate: true,
            async handler() {
                if (!this.value) {
                    return;
                }
                await this.getFile();
            }
        }
    },
    methods: {
        async deleteFile() {
            this.$emit("input", null);
        },
        async getFile() {
            this.file = await get("file", this.scope, this.value);
        },
        onInput(file) {
            this.$emit("input", file);
        }
    },
}
</script>
<style scoped>
.file-gap {
    gap: 0.625rem;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 1rem;
}
</style>
